import type { Quota } from '../../domain/quota';
import { EMPTY_QUOTA, decreaseQuota } from '../../domain/quota';
import { queryClient } from '../../queryClient';

import { insightsQueryKey } from './insightsQueryKey';

export const decreaseEmailsQuota = () =>
  queryClient.setQueryData<Quota>(insightsQueryKey.emailsQuota(), (quota: Quota | undefined) => {
    if (!quota) {
      return EMPTY_QUOTA;
    }

    return decreaseQuota(quota);
  });
